import * as React from 'react';
import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import { Divider, IconButton, Typography, FormControl, InputLabel, Select, MenuItem} from '@mui/material';
import { printVariable } from '@util/helper';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { useMediaQuery, useTheme } from "@mui/material";
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import useAlert from "@hooks/useAlert";
import moment from 'moment';

const ManagerSmstPartAddtion = ({record, dialogHandler, shortLectures, callback}) =>  {
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const schola = useSelector(state => state.scholaReducer)
  const theme = useTheme()
  const {alert, renderAlert} = useAlert()

  const handleClose = (event, reason)=> {
    if(reason && reason === "backdropClick") {
      return
    }
    else {
      dialogHandler[1](false)
    }
  }

  const onChangeState = async (phase, statCode) => {
		const url = `/smst/phase/${record.id}/${phase}/${statCode}`
		openIndicator()
		const resp = await WebService.post(url)
		closeIndicator()
		if (resp.repCode !== "ack") {
			alert(resp.repMessage)
      return
		} else {
			alert("처리되었습니다.", () => {
        if(callback) {
          callback()
        }
        handleClose()  
      })
		}
	}

  const onLoad = async() => {
  }

  useEffect(() => {
    onLoad()
  }, [])

  return (
    <Fragment>
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth='sm' fullWidth>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            추가모집 대상 강좌 
          </Typography>
          <Divider />
        </DialogTitle>
        <DialogContent>
          <div style={{overflow:'auto'}}>
            {
              shortLectures.map((lecture, idx) =>(
                <Typography key={idx} variant='body2'>
                  {idx+1}. {lecture.title} ({lecture.reqNum}/{lecture.rcrNum})
                </Typography>
              ))
            }
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>취소</Button>
          <Button onClick={() => onChangeState(1.11, 'T002')} variant='contained'>추가모집 시작</Button>
        </DialogActions>
      </Dialog>
      {renderSnackbar()}
      {renderIndicator()}
      {renderAlert()}
    </Fragment>
	)
}

export default ManagerSmstPartAddtion
